// Web Vitals reporter. Runs once in production; fires each metric back to:
//   1. Our own /api/analytics/web-vitals endpoint (for the admin dashboard).
//   2. Google Analytics 4 (if REACT_APP_GA_ID was set at build time) via the
//      already-loaded gtag() global from index.html.
//
// We collect Core Web Vitals: LCP, CLS, INP, FCP, TTFB. Failures are silent —
// telemetry must never break the user experience.

import { onCLS, onLCP, onINP, onFCP, onTTFB } from "web-vitals";

const API = process.env.REACT_APP_BACKEND_URL;

function sessionId() {
    try {
        let sid = localStorage.getItem("jw_sid");
        if (!sid) {
            sid = (crypto.randomUUID?.() || `${Date.now()}-${Math.random()}`);
            localStorage.setItem("jw_sid", sid);
        }
        return sid;
    } catch {
        return "anon";
    }
}

function report({ name, value, rating, id }) {
    const payload = {
        name,
        value: Number(value.toFixed(2)),
        rating,
        session_id: sessionId(),
        path: window.location.pathname,
        ua: navigator.userAgent.slice(0, 200),
        metric_id: id,
    };
    // Use sendBeacon so telemetry doesn't compete with page unload / nav.
    try {
        const blob = new Blob([JSON.stringify(payload)], { type: "application/json" });
        navigator.sendBeacon?.(`${API}/api/analytics/web-vitals`, blob)
            || fetch(`${API}/api/analytics/web-vitals`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
                keepalive: true,
            }).catch(() => {});
    } catch { /* noop */ }

    // Mirror to GA4 if it's loaded.
    if (typeof window.gtag === "function" && window.__GA_ID) {
        window.gtag("event", name, {
            value: Math.round(name === "CLS" ? value * 1000 : value),
            metric_id: id,
            metric_rating: rating,
            non_interaction: true,
        });
    }
}

export function reportWebVitals() {
    // Skip in dev to avoid noise while iterating.
    if (process.env.NODE_ENV !== "production") return;
    onCLS(report);
    onLCP(report);
    onINP(report);
    onFCP(report);
    onTTFB(report);
}
